/*
 * Copyright (c) 2025. World Wide Generation Ltd
 */

import { getMonthOptions, getYearDropdownOptions } from '@utils/date';
import { getPeriodOptions, DataPeriods } from '@utils/dataPeriods';
import {
  ALL_CHECK_TYPES,
  ALL_STATUSES,
  DATA_QUALITY_CHECK_LABELS,
  DataQualityIssueType,
  StatusFilter,
} from '@api/data-quality';

export const POLL_INTERVAL = 5000;

// Filter options
export const STATUS_OPTIONS = ALL_STATUSES.map((status) => ({
  value: status,
  label: status.charAt(0).toUpperCase() + status.slice(1),
  searchString: status,
}));

export const CHECK_TYPE_OPTIONS = ALL_CHECK_TYPES.map((type) => ({
  value: type,
  label: DATA_QUALITY_CHECK_LABELS[type],
  searchString: DATA_QUALITY_CHECK_LABELS[type],
}));

export const MONTH_OPTIONS = getMonthOptions().map((option) => ({
  value: option.value.toString(),
  label: option.label,
  searchString: option.label,
}));

export const YEAR_OPTIONS = getYearDropdownOptions(10, 3).map((option) => ({
  value: option.value.toString(),
  label: option.label.toString(),
  searchString: option.label.toString(),
}));

export const PERIOD_OPTIONS = getPeriodOptions().map((option) => ({
  value: option.value,
  label: option.label,
  searchString: option.label,
}));

// Default years: last 2 years + current year + future years (up to 3)
const getDefaultYears = (): string[] =>
  getYearDropdownOptions(2, 3).map((option) => option.value.toString());

// All 12 months (0-indexed)
const ALL_MONTHS = Array.from({ length: 12 }, (_, i) => i.toString());

export interface FilterState {
  checkTypes: DataQualityIssueType[];
  statuses: StatusFilter[];
  months: string[];
  years: string[];
  periods: DataPeriods[];
  initiativeIds: string[];
}

export const DEFAULT_FILTERS: FilterState = {
  checkTypes: ALL_CHECK_TYPES,
  statuses: ALL_STATUSES,
  months: ALL_MONTHS,
  years: getDefaultYears(),
  periods: [DataPeriods.Yearly],
  initiativeIds: [],
};

export interface ResultsFilterState {
  initiativeNames: string[];
  issueTypes: DataQualityIssueType[];
  statuses: string[];
}

export const DEFAULT_RESULTS_FILTERS: ResultsFilterState = {
  initiativeNames: [],
  issueTypes: [],
  statuses: [],
};
